export enum ReturnValidationReason {
    InvalidReturnAuthNumber = "InvalidReturnAuthNumber",
    ReturnAlreadySubmitted = "ReturnAlreadySubmitted",
    InvalidShipToBranch = "InvalidShipToBranch",
    InvalidSoldToBranch = "InvalidSoldToBranch",
    InvalidDealerReferenceNumber = "InvalidDealerReferenceNumber",
    InvalidReasonCode = "InvalidReasonCode",
    UnderMinimumAmount = "UnderMinimumAmount",
    InvalidVendorNumber = "InvalidVendorNumber",
    ReturnAlreadyExisted = "ReturnAlreadyExisted",
    InvalidStatusToMaintain = "InvalidStatusToMaintain",
    InvalidItemNumber = "InvalidItemNumber",
    ItemNotReturnable = "ItemNotReturnable",
    ItemIsRPISourced = "ItemIsRPISourced",
    ItemNotLiterature = "ItemNotLiterature",
    InvalidSalesOrderNumber = "InvalidSalesOrderNumber",
    InvalidSalesOrderLineNumber = "InvalidSalesOrderLineNumber",
    ReturnQtyGreaterThanShippedQty = "ReturnQtyGreaterThanShippedQty",
    FailureCalculatingShipPeriod = "FailureCalculatingShipPeriod",
    ExpressLineEnteredOutsideExpressPeriod = "ExpressLineEnteredOutsideExpressPeriod",
    ItemReturnIndicatorSetToNonExpressReturn = "ItemReturnIndicatorSetToNonExpressReturn",
    ItemNotMarkedFastMediumMoving = "ItemNotMarkedFastMediumMoving",
    ItemMarkedDropShip = "ItemMarkedDropShip",
    ItemMarkedMAO = "ItemMarkedMAO",
    ItemMarkedDiscDontSell = "ItemMarkedDiscDontSell",
    ItemMarkedHAZMAT = "ItemMarkedHAZMAT",
    QtyOutsidePackageQty = "QtyOutsidePackageQty",
    QtyPcUOMOutsidePackageQty = "QtyPcUOMOutsidePackageQty",
    ItemMissingPricing = "ItemMissingPricing",
    BelowLineMinDollarAmount = "BelowLineMinDollarAmount",
    BelowMinDollarAmount = "BelowMinDollarAmount",
    OverMaxLineItems = "OverMaxLineItems",
    UploadError = "UploadError",
    NotAvailableToBranch = "NotAvailableToBranch",
    Unknown = "Unknown",
}
